import { useId, useState } from 'react';
import { VISIBILITIES, type Visibility } from '../../core/types';
import { AUDIENCE } from '../format';

/**
 * Hidden, 240 Labs, or public (R9, R10), each with the one line that says who can open the
 * link. One change is one request; the control is held still until the Worker answers.
 */
export function VisibilityControl({ value, onChange }: { value: Visibility; onChange(next: Visibility): Promise<void> }) {
  const id = useId();
  const [saving, setSaving] = useState(false);
  const [failure, setFailure] = useState(false);
  const choose = async (next: Visibility) => {
    if (saving || next === value) return;
    setSaving(true); setFailure(false);
    try { await onChange(next); } catch { setFailure(true); } finally { setSaving(false); }
  };
  return <fieldset className="visibility" disabled={saving}>
    <legend>Who can open your page</legend>
    {VISIBILITIES.map((option) => <label key={option} className="visibility-option">
      <input type="radio" name={`${id}-visibility`} value={option} checked={value === option} aria-labelledby={`${id}-${option}-label`} aria-describedby={`${id}-${option}`} onChange={() => void choose(option)} />
      <span id={`${id}-${option}-label`} className="visibility-label">{AUDIENCE[option].label}</span>
      <span id={`${id}-${option}`} className="visibility-line">{AUDIENCE[option].line}</span>
    </label>)}
    {failure && <p className="field-error" role="alert">That didn’t save. Try again.</p>}
  </fieldset>;
}
